export default "__VITE_ASSET__C7CQ4dC6__"